import { FlexBox, Text } from '@trmediaab/zebra';
import { sortByBetTypePriority } from '@trmediaab/zebra-utils';
import PropTypes from 'prop-types';

import Time from '~/components/Time';
import { betTypePropType } from '~/utils/prop-types';
import {
  formatFirstPrize,
  formatTrackStateEnum,
  getDistance,
  getStartMethod,
} from '~/utils/race';

import InfoBadge from '../InfoBadge';
import Proposition from './Proposition';

const RaceInfo = ({ race, primaryBetType }) => {
  const {
    meet,
    race_number: raceNumber,
    base_dist: baseDist,
    proposition,
    first_prize: firstPrize,
    start_method_id: startMethodId,
    track_state: trackState,
    start_time: startTime,
    race_name: raceName,
  } = race;

  let { legs } = race;

  let title = null;

  if (legs != null) {
    legs = sortByBetTypePriority([...legs], 'bet_type');

    if (primaryBetType != null) {
      const primaryBetTypeLeg = legs.find(
        leg => leg.bet_type === primaryBetType,
      );
      if (primaryBetTypeLeg != null) {
        title = `Avdelning ${primaryBetTypeLeg.leg}`;
      }
    } else {
      title = `Lopp ${race.race_number}`;
    }
  }

  const badges = [
    baseDist && getDistance(race),
    startMethodId && getStartMethod(startMethodId),
    firstPrize && formatFirstPrize(race),
    trackState && formatTrackStateEnum(trackState),
  ].filter(Boolean);

  return (
    <FlexBox flexDirection="column" gap="3" px="3" py="20px" bg="white">
      <FlexBox justifyContent="space-between">
        <Text fontWeight="bold" fontSize="22px">
          {title}
        </Text>
        {startTime != null && (
          <InfoBadge>
            Start <Time date={new Date(startTime)} format="HH:mm" />
          </InfoBadge>
        )}
      </FlexBox>

      {badges.length > 0 && (
        <FlexBox gap="2">
          {badges.map((badge, idx) => (
            <InfoBadge key={idx} isFirst={idx === 0}>
              {badge}
            </InfoBadge>
          ))}
        </FlexBox>
      )}

      <Proposition
        proposition={proposition}
        trackName={meet.track_name}
        raceNumber={raceNumber}
        raceName={raceName}
      />
    </FlexBox>
  );
};

RaceInfo.propTypes = {
  race: PropTypes.object.isRequired,
  primaryBetType: betTypePropType,
};

export default RaceInfo;
